import { render, staticRenderFns } from "./addCom.vue?vue&type=template&id=57f85f13&scoped=true&"
import script from "./addCom.vue?vue&type=script&lang=js&"
export * from "./addCom.vue?vue&type=script&lang=js&"
import style0 from "./addCom.vue?vue&type=style&index=0&id=57f85f13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f85f13",
  null
  
)

/* custom blocks */
import block0 from "./addCom.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Fcache.amap.com%2Flbs%2Fstatic%2Fmain1119.css"
if (typeof block0 === 'function') block0(component)

component.options.__file = "addCom.vue"
export default component.exports